import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getPartnerHotels({
  payload: { options }
}: ReturnType<typeof Actions.getPartnerHotels>) {
  // const {
  //   me: { organization }
  // } = yield select((state: ApplicationState) => state)

  const params = []

  if (options.request_agency_ids && options.request_agency_ids.length) {
    params.push(`request_agency_ids=${options.request_agency_ids.join(',')}`)
  }

  if (options.request_ids && options.request_ids.length) {
    params.push(`request_ids=${options.request_ids.join(',')}`)
  }

  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/partners/${options.partner_id}/hotels?${params.join(
        '&'
      )}&page_size=10&page=${options.page || 1}`
    )

    if (response.ok) {
      const { partner_hotels } = response.data
      yield put(Actions.getPartnerHotelsSuccess({ partner_hotels }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getPartnerHotelsFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getPartnerHotelsFailure(message))
  }
}

export function* sendPartnerHotel({
  payload: { partner_hotel }
}: ReturnType<typeof Actions.sendPartnerHotel>) {
  try {
    // const {
    //   partners,
    //   me: { user }
    // } = yield select((state: ApplicationState) => state)

    const responsePayload = { partner_hotel }
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/partners/${partner_hotel.partner_id}/hotels`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendPartneHotelSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendPartneHotelFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendPartner', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendPartneHotelFailure(message))
  }
}
